import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import * as z from "zod";
import { zodValidator } from "@tanstack/zod-adapter";
import { MeetingsPage } from "./-components/MeetingsPage";
import {
  PLATFORM_OPTIONS,
  SEVERITY_OPTIONS,
  STATUS_OPTIONS,
} from "./-components/meetings-utils";
import { meetingsListQueryOptions } from "@/lib/queries/meetings";

const searchSchema = z.object({
  page: z.number().int().positive().default(1).catch(1),
  per_page: z.number().int().positive().max(100).default(10),
  search: z.string().optional(),
  date_filter: z
    .enum(["all", "today", "week", "month", "year", "custom"])
    .optional(),
  date_from: z.string().optional(),
  date_to: z.string().optional(),
  state_group: z.array(z.enum(STATUS_OPTIONS)).default(["All"]).catch(["All"]),
  severity: z.array(z.enum(SEVERITY_OPTIONS)).default(["All"]).catch(["All"]),
  platform: z.array(z.enum(PLATFORM_OPTIONS)).default(["All"]).catch(["All"]),
  scope: z.enum(["own", "organization"]).optional(),
});

export const Route = createFileRoute("/_app/meetings/")({
  component: RouteComponent,
  validateSearch: zodValidator(searchSchema),
  search: {
    middlewares: [
      stripSearchParams({
        search: "",
        state_group: ["All"],
        severity: ["All"],
        platform: ["All"],
      }),
    ],
  },
  loaderDeps: ({ search }) => search,
  loader({ context: { queryClient }, deps }) {
    const hasStatusFilter =
      deps.state_group.length > 0 && !deps.state_group.includes("All");
    const apiStatusFilters = hasStatusFilter ? deps.state_group : undefined;

    const hasSeverityFilter =
      deps.severity.length > 0 && !deps.severity.includes("All");
    const apiSeverityFilters = hasSeverityFilter ? deps.severity : undefined;

    const hasPlatformFilter =
      deps.platform.length > 0 && !deps.platform.includes("All");
    const apiPlatformFilters = hasPlatformFilter ? deps.platform : undefined;

    queryClient.ensureQueryData(
      meetingsListQueryOptions({
        ...deps,
        search: deps.search ?? "",
        state_group: apiStatusFilters,
        severity: apiSeverityFilters,
        platform: apiPlatformFilters,
      }),
    );
  },
});

function RouteComponent() {
  return <MeetingsPage title="My Meetings" view="mine" />;
}
